import { useCallback } from 'react'
import { NyuSeriesProperties } from '../../../../../shared/types'
import Shape from './Shape'
import { SHAPES } from '../HighContrastMode/constants'

type CustomDotProps = {
    cx: number
    cy: number
    stroke: string
    payload: any
    value: any
}

type UseCustomDotProps = {
    isHighContrastActive: boolean
    seriesProperties: NyuSeriesProperties
    shapeVisibilityMap: Map<string, Set<number>>
}

export function useCustomDot({
    isHighContrastActive,
    seriesProperties,
    shapeVisibilityMap,
}: UseCustomDotProps) {
    const CustomDot = useCallback(
        (props: CustomDotProps, shapeIndex: number) => {
            const { cx, cy, stroke, payload, value } = props

            // Basic validation
            if (!isHighContrastActive || !value || !payload || !cx || !cy) {
                return <g />
            }

            // Check if this point should show a shape
            const lineDataKey = seriesProperties[shapeIndex]?.key
            if (lineDataKey) {
                const visibleTimes = shapeVisibilityMap.get(
                    `${shapeIndex}-${lineDataKey}`
                )
                if (!visibleTimes || !visibleTimes.has(payload.time)) {
                    return <g />
                }
            }

            const shape = SHAPES[shapeIndex % SHAPES.length]
            return <Shape cx={cx} cy={cy} stroke={stroke} shape={shape} />
        },
        [isHighContrastActive, seriesProperties, shapeVisibilityMap]
    )

    const createDotComponent = useCallback(
        (lineIndex: number) => {
            return (props: any) => CustomDot(props, lineIndex)
        },
        [CustomDot]
    )

    return { CustomDot, createDotComponent }
}
